
<div class="w-100">
    <c-column-header
        v-if   = "title"
        :label = "title"
        class  = "primary"
    >
        <template v-slot:filter>
            <div class="c-toolbar">
                <c-toolbar-button
                    icon     = "mdi-reload"
                    :tooltip = "$t('dms.tree.reload')"
                    color    = "white"
                    size     = "20"
                    @click   = "onReload"
                />
            </div>
        </template>
    </c-column-header>

    <div
        class  = "tree-scroll-panel"
        :class = "border ? 'lm-border' : null"
    >
        <v-treeview
            :items        = "folder"
            item-key      = "id"
            item-text     = "name"
            item-children = "entries"
            :style = "'height: ' + height + 'px'"
            hoverable
            dense
        >
            <template v-slot:label="{ item, open }">
                <div class="v-flex">
                    <div class="no-frame" style="width: 70%">
                        <div class="v-flex" v-if  = "item.type === 3">
                            <p-dms-treeview-folder
                                :folder = "item"
                                :open   = "open"
                            />
                        </div>

                        <p-dms-treeview-file
                            :item     = "item"
                            @document = "onDocument"
                        />
                     </div>
                </div>
            </template>
        </v-treeview>
    </div>
</div>
